/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '../../../../app/@shared/tracking/tracking.module';
import * as i2 from './tracking.component.ngfactory';
import * as i3 from '@angular/common/http';
import * as i4 from '@angular/common';
import * as i5 from 'ngx-cookie/src/cookie-options-provider';
import * as i6 from '../../../../app/@shared/tracking/error-tracking.service';
import * as i7 from '../../../../app/@shared/auth/auth.service';
import * as i8 from '../../../../app/@shared/tracking/tracking.config';
import * as i9 from '../../../../app/@shared/tracking/performance-tracking.service';
import * as i10 from 'ngx-cookie/index';
import * as i11 from '../../../../app/@shared/auth/auth.module';
export const TrackingModuleNgFactory:i0.NgModuleFactory<i1.TrackingModule> = i0.ɵcmf(i1.TrackingModule,
    ([] as any[]),(_l:any) => {
      return i0.ɵmod([i0.ɵmpd(512,i0.ComponentFactoryResolver,i0.ɵCodegenComponentFactoryResolver,
          [[8,[i2.TrackingComponentNgFactory]],[3,i0.ComponentFactoryResolver],i0.NgModuleRef]),
          i0.ɵmpd(4608,i3.HttpXsrfTokenExtractor,i3.ɵg,[i4.DOCUMENT,i0.PLATFORM_ID,
              i3.ɵe]),i0.ɵmpd(4608,i3.ɵh,i3.ɵh,[i3.HttpXsrfTokenExtractor,i3.ɵf]),
          i0.ɵmpd(5120,i3.HTTP_INTERCEPTORS,(p0_0:any) => {
            return [p0_0];
          },[i3.ɵh]),i0.ɵmpd(4608,i3.ɵd,i3.ɵd,([] as any[])),i0.ɵmpd(6144,i3.XhrFactory,
              (null as any),[i3.ɵd]),i0.ɵmpd(4608,i3.HttpXhrBackend,i3.HttpXhrBackend,
              [i3.XhrFactory]),i0.ɵmpd(6144,i3.HttpBackend,(null as any),[i3.HttpXhrBackend]),
          i0.ɵmpd(5120,i3.HttpHandler,i3.ɵinterceptingHandler,[i3.HttpBackend,[2,i3.HTTP_INTERCEPTORS]]),
          i0.ɵmpd(4608,i3.HttpClient,i3.HttpClient,[i3.HttpHandler]),i0.ɵmpd(4608,
              i5.CookieOptionsProvider,i5.CookieOptionsProvider,[i5.COOKIE_OPTIONS,
                  i0.Injector]),i0.ɵmpd(4608,i6.ErrorTracking,i6.ErrorTracking,[i7.Auth,
              i8.TRACKING_CONFIG]),i0.ɵmpd(4608,i9.PerformanceTracking,i9.PerformanceTracking,
              ([] as any[])),i0.ɵmpd(512,i3.HttpClientXsrfModule,i3.HttpClientXsrfModule,
              ([] as any[])),i0.ɵmpd(512,i3.HttpClientModule,i3.HttpClientModule,([] as any[])),
          i0.ɵmpd(512,i10.CookieModule,i10.CookieModule,([] as any[])),i0.ɵmpd(512,
              i11.AuthModule,i11.AuthModule,([] as any[])),i0.ɵmpd(512,i1.TrackingModule,
              i1.TrackingModule,([] as any[])),i0.ɵmpd(256,i3.ɵe,'XSRF-TOKEN',([] as any[])),
          i0.ɵmpd(256,i3.ɵf,'X-XSRF-TOKEN',([] as any[]))]);
    });
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL21udC9qZW5raW5zLXNsYXZlLXdvcmtzcGFjZS93b3Jrc3BhY2UvZ2FmLWJ1aWxkLXdlYmFwcC1jb21wYXQvd2ViYXBwL3NyYy9hcHAvQHNoYXJlZC90cmFja2luZy90cmFja2luZy5tb2R1bGUubmdmYWN0b3J5LnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vbW50L2plbmtpbnMtc2xhdmUtd29ya3NwYWNlL3dvcmtzcGFjZS9nYWYtYnVpbGQtd2ViYXBwLWNvbXBhdC93ZWJhcHAvc3JjL2FwcC9Ac2hhcmVkL3RyYWNraW5nL3RyYWNraW5nLm1vZHVsZS50cyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/$$_gendir/app/@shared/tracking/tracking.module.ngfactory.ts